import React from "react";

const Banner = () => {
  return (
    <div className="container px-8 lg:px-4 max-w-[1280px]">
      <div className=" rounded-lg text-center bgBanner bg-cover py-48 relative overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full translate-x-1/2 translate-y-1/2 flex flex-col justify-center items-center bg-indigo-900 bg-opacity-90 gap-8">
          <h2 className="text-4xl font-serif text-white">
            Find the <span className="font-bold text-orange-600">best way</span>{" "}
            to create a successful project
          </h2>

          <button className="bg-amber-500 w-fit text-2xl rounded-lg mx-auto font-bold lg:mx-0 activeButton">
            <a
              href="#contactus"
              className="flex gap-4 items-center text-indigo-900 px-4 py-3 hover:gap-6 hover:transition duration-200 ease-in-out"
            >
              Contact Us
              <svg className="stroke-indigo-900  w-6 h-6" viewBox="0 0 24 25">
                <path
                  d="M14 5.22101L21 12.221M21 12.221L14 19.221M21 12.221L3 12.221"
                  stroke="current"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
